import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../../components/loader';
import moment from'moment';
import { fetchAdministereds } from '../../../actions/administered';
import { addMedication } from '../../../actions/medicalRecords';
import DatePicker from 'react-datepicker';
import Select from 'react-select';
import { forceInputUppercase } from "../../../utils/helper";
import {fetchBreederDurartion, addBreederVaccine, createdBreederVaccine } from "../../../actions/breeders";
// import { createAdministered } from '../../actions/administered';

const $ = window.$;
const initialState = {
    date: moment().toDate(),
    administeredList: [],
    administeredId: '',
    more_info: '',
    loading: false,
    dewormings:[],
    vaccinations:[],
    breeders_vaccine_duration:[],
    breeders_vaccine_duration_id:null
}

class AddMedication extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }
    submit(e){
        e.preventDefault();    
        if(this.state.administeredId &&  this.state.breeders_vaccine_duration_id ){
            this.setState({ loading: true });
        let breederid = this.props.match.params.id;
        let data = {
            PetShopId: this.props.petShop.currentPetshop.id,     
            MedicationId: this.state.administeredId,
            DurationId: this.state.breeders_vaccine_duration_id,
            BreederId: breederid
        };    

        this.props.addBreederVaccine(data);
        
    }
    else{
        NotificationManager.warning('Medication data incomplete.');
    }   
       
    }

    closeModal = () => {
        $('#add_medication').modal('hide');
        // this.resetState();
    }
    componentDidMount = () => {
        this.props.fetchAdministereds();
        this.props.fetchBreederDurartion();
    }

    componentWillReceiveProps= (nextProps) => {
        if(this.props.newMedication !== nextProps.newMedication) {
            this.setState(initialState);
            this.props.fetchAdministereds();
            NotificationManager.success("Vaccination Added Successfully")
            $('#add_medication').modal('hide');
        }
        if(this.props.administeredList !== nextProps.administeredList) {
            let VaccinationOptions = [{label:'Select an option',value:'N/A'}];
            let DewormingOptions = [{label:'Select an option',value:'N/A'}];
            
            nextProps.administeredList.map(p => {
                if(p.type==='vaccine'){
                    VaccinationOptions.push({label: p.name, value: p.id});
                }
                if(p.type==='deworm'){
                    DewormingOptions.push({label: p.name, value: p.id});
                }
            });
            
            this.setState({vaccinations: VaccinationOptions, dewormings:DewormingOptions});
            // let options = [];
            // nextProps.administeredList.map(p => {
            //   options.push({label: p.name, value: p.id});
            // });
            // this.setState({administeredList: options});
            if(nextProps.administeredList.length > 0) {
                this.setState({administeredId: 'N/A'});
            }            
        }

        if (
            nextProps.breeders_vaccine_duration &&
            this.props.breeders_vaccine_duration !== nextProps.breeders_vaccine_duration &&
            nextProps.breeders_vaccine_duration.length > 0
          ) {
            let options = [{ label: "Select Duration", value: "none" }];
            nextProps.breeders_vaccine_duration.map(p => {
              options.push({ label: p.label, value: p.id, days: p.days });
            });
            this.setState({ breeders_vaccine_duration: options });
            if (nextProps.breeders_vaccine_duration > 0) {
              this.setState({ breeders_vaccine_duration_id: "none" });
            }
          }

          if(this.props.newVaccine !== nextProps.newVaccine) {
           // this.setState(initialState);      
           // let vac = this.state.breederInfo;
            this.setState({ breeders_vaccine_duration_id: null }); 
            this.props.createdBreederVaccine(nextProps.newVaccine);      
            $('#add_medication').modal('hide');
            NotificationManager.success("Vaccination Added Successfully")
 
        }
    };

    changeDate = (value) => {
        this.setState({ date: value })
    }

    changeAdministered = (selected) => {
        if(selected) {
          this.setState({administeredId: selected.value});
        }
    }
    
    changeVal = (event) => {
        forceInputUppercase(event);
        this.setState({[event.target.name]: event.target.value})
    };

    changeBreederVaccineDuration = selected => {
        if (selected) {   
          this.breeder_vaccine_duration_label = selected.label;
          this.breeder_vaccine_duration_days = selected.days;
          this.setState({ breeders_vaccine_duration_id: selected.value });
        }
      };

    render() {
        const {date, administeredId, more_info, vaccinations,dewormings,administeredList,breeders_vaccine_duration,
            breeders_vaccine_duration_id} = this.state; 
        const meditype= this.props.mediType;
        return (
            <div className="modal fade show" id="add_medication" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">                   
                        <form className="m-form">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">New {meditype==='vaccine'?'Vaccination':meditype==='deworm'?'Treatment':null} Schedule</h5>
                                <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="m-form__section m-form__section--first">
                                            <div className="form-group m-form__group row">
                                                <label className="col-xl-3 col-lg-3 col-form-label">Interval:</label>
                                                <div className="col-xl-9 col-lg-9">
                                                <Select
                                                    options={breeders_vaccine_duration}
                                                    value={breeders_vaccine_duration_id}
                                                    name="breeders_vaccine_duration_id"
                                                    onChange={this.changeBreederVaccineDuration}
                                                    placeholder="Select the Timeline"
                                                  />
                                                    <span className="m-form__help">Please enter date of administered</span>
                                                </div>
                                            </div>
                                            <div className="form-group m-form__group row">
                                                <label className="col-xl-3 col-lg-3 col-form-label">{meditype==='vaccine'?'Vaccination':meditype==='deworm'?'Treatment':null} Name:</label>
                                                <div className="col-xl-9 col-lg-9">
                                                    <Select options={meditype==='vaccine'?vaccinations :meditype==='deworm'? dewormings : null} value={ administeredId } name="administeredId" onChange={ this.changeAdministered } placeholder="Select the administered type" />
                                                    <span className="m-form__help">Please select vaccination</span>
                                                </div>
                                            </div>                                      
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">                         
                                <div>
                                    <button type="button" className="btn btn-secondary m-btn--pill mx-2" onClick={this.closeModal}>Close</button>
                                    <button onClick={(e) => this.submit(e)} type="submit" className="btn btn-primary m-btn--pill">Submit</button>
                                </div>
                         
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    administeredList: state.administeredTypeReducer.administeredList,
    newMedication: state.medicalRecordsReducer.newMedication,
    breeders_vaccine_duration: state.breederReducer.breederVaccineDuration,
    newVaccine : state.breederReducer.newVaccine
});

const mapDispatchToProps = dispatch => ({
    fetchAdministereds: () => {
        dispatch(fetchAdministereds());
    },
    addMedication: (v) => {
        dispatch(addMedication(v));
    },
    fetchBreederDurartion: () => {
        dispatch(fetchBreederDurartion());
    },
    addBreederVaccine: (v) => {
        dispatch(addBreederVaccine(v));
    },
    createdBreederVaccine:(v) => {
        dispatch(createdBreederVaccine(v))
    }
})


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AddMedication));
